import React from "react";
import AppShell from "../components/layout/AppShell";
import { useParams } from "react-router-dom";
import { ClockCountdown, CheckCircle } from "@phosphor-icons/react";

const MODULE_META = {
  crm: { title: "CRM & Lead Management", num: 4,
    features: ["Lead capture", "Kanban pipeline", "Follow-ups & reminders", "Complaint tickets", "WhatsApp logs", "Campaigns"] },
  operations: { title: "Operations Engine", num: 5,
    features: ["Daily task planning", "Route generation", "Task assignment", "Live monitoring", "Missed task detection", "Reassignment"] },
  live: { title: "Live Operations Dashboard", num: 6,
    features: ["Real-time KPIs", "Staff/vehicle map", "Alerts center", "Zone performance", "WebSocket updates"] },
  staff: { title: "Staff Management", num: 7,
    features: ["Staff database", "Role control", "Attendance with GPS", "Device lock", "Performance metrics"] },
  fleet: { title: "Fleet Management", num: 8,
    features: ["Vehicle registry", "Driver assignment", "Trip logs", "Fuel management", "Maintenance alerts", "Odometer validation"] },
  qr: { title: "QR Bag & Inventory", num: 9,
    features: ["Unique QR generation", "Assignment to customers", "Lifecycle tracking", "Missing bag alerts", "Stock inventory"] },
  disposal: { title: "Disposal Center", num: 10,
    features: ["Vehicle check-in", "QR re-scan", "Weight reconciliation", "Mismatch detection", "Processing logs"] },
  fraud: { title: "Fraud & Control System", num: 11,
    features: ["GPS deviation detection", "Idle monitoring", "Task compliance", "Quantity audit", "Device security", "Audit logs"] },
  finance: { title: "Finance & Payments", num: 12,
    features: ["Transactions", "Invoice generation", "Manual billing (role-gated)", "Outstanding dues", "Razorpay integration", "Refunds"] },
  analytics: { title: "Analytics & Reports", num: 13,
    features: ["KPI overview", "Operations analytics", "Staff performance", "Customer retention", "Waste & CO₂ trends", "Financial reports"] },
  certificates: { title: "Certificate Module", num: 14,
    features: ["Auto-generation", "Unique number format", "PDF with QR", "Public verification", "Template editor"] },
  notifications: { title: "Notifications", num: 15,
    features: ["WhatsApp triggers", "Broadcast", "Event-based alerts", "Templates"] },
  settings: { title: "System Settings", num: 16,
    features: ["Role matrix", "Tenant config", "API keys", "Feature toggles", "Security", "Backup & restore"] },
  franchise: { title: "Franchise & Partner", num: "+",
    features: ["Onboarding with KYC", "Territory management", "Performance tracking", "Revenue share payouts", "Support tickets"] },
};

export default function ModuleStub() {
  const { name } = useParams();
  const meta = MODULE_META[name] || { title: name, num: "?", features: [] };
  return (
    <AppShell title={meta.title} subtitle={`Module ${meta.num}`}>
      <div className="max-w-4xl">
        <div className="bg-white border border-[#E5E2D9] rounded-md p-10">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-md bg-[#C25D38]/10 flex items-center justify-center">
              <ClockCountdown size={22} color="#C25D38" weight="duotone" />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-[#8A8780]">Coming soon</div>
              <div className="font-heading text-2xl">Module {meta.num}: {meta.title}</div>
            </div>
          </div>
          <p className="mt-6 text-[#5C5A55] leading-relaxed max-w-xl">
            This module is part of the full Rescigo Health platform. The foundation
            (auth, master control, pricing engine, customer management) is already
            production-ready and powers the data model for this module.
          </p>
          <div className="mt-8">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#5C5A55] mb-3">Planned features</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {meta.features.map(f => (
                <div key={f} className="flex items-center gap-2 text-sm text-[#1A1A1A] px-4 py-2.5 border border-[#E5E2D9] rounded-md bg-[#F7F6F2]">
                  <CheckCircle size={14} color="#2D5A27" weight="duotone" />
                  {f}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  );
}
